<template>
  <div class="forget">
    <div class="forget_top">
        <div>
            <img src="../../assets/logo.png" alt="">
            <div>账号设置</div>
        </div>
    </div>

    <div class="forget_center">
        <a-form :form="form">

            <a-form-item class="formTitle">
                找回密码
            </a-form-item>

          <a-form-item >
            <a-input
              size="large"
              v-decorator="[
                'tel',
                { rules: [{ message: '请输入手机号码!' }] },
              ]"
              placeholder="请输入手机号码"
              style="width:4.12rem;height: 0.56rem;font-size: 0.16rem;"
            >
            </a-input>
          </a-form-item>

          <a-form-item >
            <a-input
              size="large"
              v-decorator="[
                'code',
                { rules: [{ message: '请输入手机验证码!' }] },
              ]"
              placeholder="请输入手机验证码"
              style="width:4.12rem;height: 0.56rem;font-size: 0.16rem;"
            >
                <a v-if="!codeTime" href="javascript:;" @click="getCode" slot="suffix" style="color: #03A2F4;">
                    获取验证码
                </a>
                <span v-else slot="suffix">{{codeTime}}</span>
            </a-input>
          </a-form-item>

          <a-form-item >
            <a-input
              type="password"
              size="large"
              v-decorator="[
                'pswd',
                { rules: [{ message: '请输入6-16位数的新密码!' }] },
              ]"
              placeholder="请输入6-16位数的新密码"
              style="width:4.12rem;height: 0.56rem;font-size: 0.16rem;"
            >
            </a-input>
          </a-form-item>

          <a-form-item >
            <a-input
              type="password"
              size="large"
              v-decorator="[
                'pswd1',
                { rules: [{ message: '请再次输入密码!' }] },
              ]"
              placeholder="请再次输入密码"
              style="width:4.12rem;height: 0.56rem;font-size: 0.16rem;"
            >
            </a-input>
          </a-form-item>

          <a-form-item >
            <a-input
              size="large"
              v-decorator="[
                'imgCode',
                { rules: [{ message: '请输入图形验证码!' }] },
              ]"
              placeholder="请输入图形验证码"
              style="width:4.12rem;height: 0.56rem;"
            >
                <template slot="suffix">
                    <img @click="getImgCode" :src="codeImg" style="width: 0.89rem; height: 0.41rem;cursor: pointer;">
                </template>
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="handleSubmit" block size="large" :loading="loading" style="width:4.12rem;height: 0.56rem;margin-top: 0.26rem;">保存</a-button>
          </a-form-item>
          <a-form-item class="toBack">
              <a class="fogetA" href="javascript:;" @click="toBack">返回登录</a>
          </a-form-item>

        </a-form>
        <p class="bottomDisc">Copyright 2019 ©来客店铺端管理平台 湘ICP备13020851号</p>
    </div>
  </div>
</template>

<script>
import { setToken } from '../../lib/tool'
import {imgURL} from '../../lib/config.js'

var deviceWidth
setHtmlFontSize()

if (window.addEventListener) {
  window.addEventListener('resize', function () {
      setHtmlFontSize()
  }, false)
}
function setHtmlFontSize () {
  // 1920是设计稿的宽度，当大于1920时采用1920宽度，比例也是除以19.20
    deviceWidth = document.documentElement.clientWidth > 1920 ? 1920 : document.documentElement.clientWidth
    document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 19.20 + 'px !important'
}

export default {
  name:'foget',
  data(){
    return {
      loading: false,
      form: this.$form.createForm(this, { name: 'loginbg' }),

      codeImg: '', //验证码图像
      imgCode: '',  //图形验证码
      codeTime: '',
      timeI: ''
    }
  },
  mounted(){
    this.codeTime = '';
    clearTimeout(this.timeI)

    this.getImgCode();
  },
  methods:{
      toBack(){
          this.$router.push({ path:'/login' })
      },
      getImgCode(){
          this.$request.post('?module=pc_api&action=Reset_password&m=get_code').then(res=>{
            if(res.code == 200){
              this.codeImg = imgURL + res.data.code_img
              this.imgCode = res.data.code
            }
          })
      },
      setCodeTime(i){
        this.timeI = setTimeout(()=>{
          i--;
          this.codeTime = i + 's后可重获'
          if(i == 0){
            this.codeTime = ''
          }else{
            this.setCodeTime(i)
          }
        },1000)
      },
      getCode(){
          let tel = this.form.getFieldValue('tel')
          if(!tel){
              this.$message.error('请输入手机号')
              return
          }

          let data = {
            phone: tel, // 手机号码
          }
          this.$request.post('?module=pc_api&action=Reset_password&m=forget_zhanghao',data).then(res=>{
              if(res.code == 200){

                let data1 = {
                  phone: tel, // 手机号码
                  message_type:0, // 短信类型
                  message_type1:0, // 短信类别
                }
                this.$request.post('?module=pc_api&action=Reset_password&m=secret_key',data1).then(res=>{
                    if(res.code == 200){
                      this.codeTime = '60s后可重获'
                      this.setCodeTime(60)
                    }else{
                      this.$message.warning(res.message)
                    }
                })

              }else{
                this.$message.warning(res.message)
              }
          })
      },
      handleSubmit(){

        this.form.validateFields((err, values) => {
          if (!err) {
            if(!values.tel){
              this.$message.warning('请输入手机号码')
              return
            }

            if(!values.code){
              this.$message.warning('请输入手机验证码')
              return
            }

            if(!values.pswd){
              this.$message.warning('请输入新密码')
              return
            }

            if(!values.pswd1){
              this.$message.warning('请再次输入密码')
              return
            }

            if(values.pswd!=values.pswd1){
              this.$message.warning('确认密码不一致')
              return
            }

            if(!values.imgCode){
              this.$message.warning('请输入图形验证码')
              return
            }

            if(values.imgCode.toUpperCase() != this.imgCode){
              this.$message.warning('图形验证码输入错误')
              return
            }

            let data = {
              phone: values.tel, // 手机号码
              keyCode: values.code, // 验证码
              password: values.pswd, // 重置密码
            }

            this.loading = true

            this.$request.post('?module=pc_api&action=Reset_password&m=forgotpassword',data).then(res=>{
              if(res.code == 200){
                this.$message.success(res.message)

                setTimeout(() => {
                  this.$router.push({ path:'/login' })
                }, 1000);
              }else{
                this.loading = false
                this.$message.warning(res.message)
              }
            }).catch(error=>{
              this.loading = false
            })
          }
        })
      }
  }
}
</script>
<style lang="less">
.forget{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #EBEEF2;

    &_top{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.8rem;
        background-color: #ffffff;
        position: sticky;
        top: 0;
        z-index: 9;

        >div{
            display: flex;
            width: 12rem;
            >img{
                width: 1.4rem;
                height: 0.47rem;
                margin-right: 0.24rem;
            }

            >div{
              display: flex;
              align-items: center;
              height: 0.47rem;
              font-size: 0.26rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #323544;
              padding-left: 0.2rem;
              border-left: 1px solid #DDDDDD;
          }
        }

    }

    &_center{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .ant-form{
            width: 10rem;
            height: 7.2rem;
            background: #FFFFFF;
            box-shadow: 0px 0.1rem 0.24rem 0px rgba(3, 162, 244, 0.24);
            border-radius: 0.08rem;
            margin-top: auto;
        }

        .formTitle{
            font-size: 0.3rem;
            line-height: 0.3rem;
            height: 0.3rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #323544;
            text-align: center;
            margin: 0.5rem 0!important;
        }

        .ant-form-item-control{
          line-height: 0.4rem;
        }

        .ant-form-item{
            text-align: center;
            margin-bottom: 0.24rem;
        }

        .toBack{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 0.06rem;
            height: 0.17rem;
        }

        .fogetA{
            font-size: 0.16rem;
            color: #03A2F4;
        }
        .fogetA:hover{
            text-decoration: underline;
        }
    }


    .bottomDisc{
        margin-top: auto;
        padding-bottom: 0.28rem;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7A82B9;
        line-height: 0.14rem;
    }

    .ant-input-lg{
      font-size: 0.16rem;
      height: 0.56rem;
    }

    .ant-btn-primary{
      font-size: 0.2rem;
    }

}
</style>